module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenters1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELIGION")]), _vm._v(", R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACE, AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THNICITY")]), _c('br'), _vm._v("General Editor: Peter J. Paris")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("Public Religion and Urban Transformation: Faith in the City")]), _c('br'), _vm._v("Edited by Lowell W. Livezey")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("Down by the Riverside: Readings in African American Religion")]), _c('br'), _vm._v("Edited by Larry G. Murphy")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("New York Glory: Religions in the City")]), _c('br'), _vm._v("Edited by Tony Carnes and Anna Karpathakis")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("Religion and the Creation of Race and Ethnicity: An Introduction")]), _c('br'), _vm._v("Edited by Craig R. Prentiss")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("God in Chinatown: Religion and Survival in New York’s"), _c('br'), _vm._v("Evolving Immigrant Community")]), _c('br'), _vm._v("Kenneth J. Guest")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("Creole Religions of the Caribbean: An Introduction from"), _c('br'), _vm._v("Vodou and Santería to Obeah and Espiritismo")]), _c('br'), _vm._v("Margarite Fernández Olmos and Lizabeth Paravisini-Gebert")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("The History of the Riverside Church in the City of New York")]), _c('br'), _vm._v("Peter J. Paris, John Wesley Cook, James Hadnut-Beumler, Lawrence H. Mamiya, Leonora Tubbs Tisdale, and Judith Weisenfeld"), _c('br'), _vm._v("Foreword by Martin E. Marty")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("Righteous Content: Black Women’s Perspectives of Church and Faith")]), _c('br'), _vm._v("Daphne C. Wiggins")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("Beyond Christianity: African Americans in a New Thought Church")]), _c('br'), _vm._v("Darnise C. Martin")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("Deeper Shades of Purple: Womanism in Religion and Society")]), _c('br'), _vm._v("Edited by Stacey M. Floyd-Thomas")]), _vm._v(" "), _c('p', {
    staticClass: "textcenters1"
  }, [_c('em', [_vm._v("Daddy Grace: A Celebrity Preacher and His House of Prayer")]), _c('br'), _vm._v("Marie W. Dallam")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-599bda9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02.vue
// module id = 63
// module chunks = 0